const columns = [
    {
        title: 'Name',
        dataIndex: 'name',
    },
    // {
    //     title: 'Email',
    //     dataIndex: 'email',
    //     sortet: true
    // },
    // {
    //     title: 'Mobile No',
    //     dataIndex: 'phoneNo',
    // },
    // {
    //     title: 'Affiliate Code',
    //     dataIndex: 'affiliateCode',
    // },
    {
        title: 'A/C No.',
        dataIndex: 'terminalID',
    },
    {
        title: 'A/C Type',
        dataIndex: 'planName',
        sortet: true
    },
    {
        title: 'User Type',
        dataIndex: 'ibUser',
        sortet: true
    },
    {
        title: 'Level',
        dataIndex: 'level',
        sortet: true
    },
    {
        title: 'Lot',
        dataIndex: 'lot',
        sortet: true
    },
    {
        title: 'Symbol',
        dataIndex: 'symbol',
        sortet: true
    },
    {
        title: 'Amount',
        dataIndex: 'ibCommission',
        sortet: true
    },
    {
        title: 'Date',
        dataIndex: 'ibCommDate',
    },
];

export default columns;